import About from './Aboutus'

export default About;